import React, { useEffect } from 'react'
// Redux
import {
  getSearchOrder,
  resetSearchSort,
  setOrderKeySearch,
  setPrintingStatusSearch,
  setSinceLasLogout,
  setStatusSearch,
  setUserIdSearch,
} from '../../features/order/orderSlice'
import { useDispatch, useSelector } from 'react-redux'
// components
import OrderTable from '../../components/order/OrderTable'
import { Switch } from '@headlessui/react'
import { setToken } from '../../features/auth/authSlice'

const Orders = () => {
  const { token, distribution_status } = useSelector((state) => state.auth)
  const { order } = useSelector((state) => state.order)
  // console.log(order)
  const distributionStatus = distribution_status?.value?.status_list
  const printingStatus = distribution_status?.value?.printing_status_list

  const dispatch = useDispatch()

  // Search
  const {
    order_key,
    user_id,
    status,
    printing_status,
    since_last_logout,
    //
    page,
    limit,
    sort_key,
    sort_order,
    company_id,
  } = useSelector((state) => state.order)

  const data = {
    order_key,
    user_id,
    status,
    page,
    printing_status,
    limit,
    sort_key,
    sort_order,
    company_id,
    since_last_logout,
  }

  useEffect(() => {
    // dispatch(getSearchOrder({ data: null, token }))
    dispatch(getSearchOrder({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res.data && res.data.result === 'success' && newToken) {
          dispatch(setToken(newToken))
        }
      })
      .catch((error) => {})
    // eslint-disable-next-line
  }, [limit, page])

  // Order Name
  const setSearchOrderName = (orderKey) => {
    dispatch(setOrderKeySearch(orderKey))
  }

  // Order number
  const setSearchOrderNumber = (userId) => {
    dispatch(setUserIdSearch(userId))
  }

  // Order Status
  const setSearchOrderStatus = (orderStatus) => {
    dispatch(setStatusSearch(orderStatus))
  }

  // Order Printing Status
  const setSearchOrderPrintStatus = (orderStatus) => {
    dispatch(setPrintingStatusSearch(orderStatus))
  }

  // Last Logout
  const lastLogoutSearchHandler = () => {
    if (since_last_logout === 0) dispatch(setSinceLasLogout(1))
    if (since_last_logout === 1) dispatch(setSinceLasLogout(0))
  }

  // submit Search
  const submitSearchHandler = (e) => {
    e.preventDefault()

    dispatch(getSearchOrder({ data, token }))
  }

  // reset condition
  const resetConditionHandler = () => {
    const data = {
      order_key: '',
      user_id: '',
      status: -1,
      printing_status: -1,
      page: 1,
      limit: 100,
      sort_key: 'created_at',
      sort_order: 'desc',
      company_id: -1,
      since_last_logout: 0,
    }
    dispatch(getSearchOrder({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res.data && res.data.result === 'success' && newToken) {
          dispatch(setToken(newToken))
        }
      })
      .catch((error) => {})
    dispatch(resetSearchSort())
  }

  return (
    <div className="w-full mb-8 px-2">
      <h1 className="text-center my-4 text-2xl leading-snug uppercase">
        注文一覧
      </h1>
      <div className="flex mb-8">
        <form className="w-full">
          <div className="flex flex-col gap-2 sm:gap-0 sm:flex-row w-full w-12/12 mb-4">
            {/* Order Number */}
            <div className="flex flex-col w-12/12 sm:w-3/12 px-2">
              <label htmlFor="order_number" className="pr-4 py-2">
                注文番号
              </label>
              <input
                name="order_number"
                value={order_key}
                onChange={(e) => setSearchOrderName(e.target.value)}
                className="w-full outline-none px-2 py-[2px] rounded-[4px] border border-gray-800 bg-white"
                type="text"
              />
            </div>
            {/* End Order Number */}

            {/* Customer ID */}
            <div className="flex flex-col w-12/12 sm:w-3/12 px-2">
              <label htmlFor="customer_id" className="pr-4 py-2">
                お客様ID
              </label>
              <input
                value={user_id}
                onChange={(e) => setSearchOrderNumber(e.target.value)}
                name="customer_id"
                className="w-full outline-none px-2 py-[2px] rounded-[4px] border border-gray-800 bg-white"
                type="text"
              />
            </div>
            {/* End Customer ID */}

            {/* Printing Status */}
            {/* <div className="flex flex-col w-12/12 sm:w-3/12 px-2">
              <label htmlFor="distribution_status" className="pr-4 py-2">
                印刷ステータス
              </label>
              <select
                value={printing_status}
                onChange={(e) =>
                  setSearchOrderPrintStatus(Math.abs(e.target.value))
                }
                className="w-full outline-none px-2 py-[3px] rounded-[4px] border border-gray-800 bg-white cursor-pointer"
              >
                <option value="">選択</option>
                {printingStatus &&
                  printingStatus.map((stat, idx) => (
                    <option key={idx} value={Math.abs(idx)}>
                      {stat}
                    </option>
                  ))}
              </select>
            </div> */}
            {/* End Printing Status */}

            {/* Distribution Status */}
            <div className="flex flex-col w-12/12 sm:w-3/12 px-2">
              <label htmlFor="distribution_status" className="pr-4 py-2">
                配布ステータス
              </label>
              <select
                value={status}
                onChange={(e) => setSearchOrderStatus(Math.abs(e.target.value))}
                className="w-full outline-none px-2 py-[3px] rounded-[4px] border border-gray-800 bg-white cursor-pointer"
              >
                <option value="">選択</option>
                {distributionStatus &&
                  distributionStatus.map((stat, idx) => (
                    <option key={idx} value={Math.abs(idx)}>
                      {stat}
                    </option>
                  ))}
              </select>
            </div>
            {/* End Distribution Status */}

            {/* Since Logout */}
            <div className="flex flex-col justify-end w-12/12 sm:w-3/12 px-2">
              <div className="py-2">
                <Switch
                  checked={since_last_logout === 1}
                  onChange={lastLogoutSearchHandler}
                  className={`${
                    since_last_logout === 1
                      ? 'bg-orange-500 border-2 border-orange-500'
                      : 'bg-orange-200 border-2 border-gray-400'
                  } relative inline-flex h-6 w-12 items-center rounded-full`}
                >
                  <span
                    className={`${
                      since_last_logout === 1
                        ? 'translate-x-6'
                        : 'translate-x-0'
                    } inline-block h-5 w-5 transform rounded-full bg-white transition`}
                  />
                </Switch>
                {/* <Switch
                  checked={since_last_logout === 1}
                  onChange={lastLogoutSearchHandler}
                  className={`${
                    since_last_logout === 1
                      ? 'bg-primary border-primary'
                      : 'bg-primary bg-opacity-40'
                  }
          relative inline-flex h-6 w-12 shrink-0 cursor-pointer rounded-full border-2 border-gray-300 transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                >
                  <span
                    aria-hidden='true'
                    className={`${
                      since_last_logout === 1
                        ? 'translate-x-6'
                        : 'translate-x-0'
                    }
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                  />
                </Switch> */}
                <p className="text-xs">
                  最終ログアウト後に登録または更新されたオーダーのみ表示
                </p>
              </div>
            </div>
            {/* End Customer ID */}
          </div>

          {/* Button */}
          <div className="flex justify-end w-12/12 px-2 gap-4 mt-8 mb-4">
            <button
              type="button"
              onClick={resetConditionHandler}
              className="p-2 bg-primary text-white rounded-sm cursor-pointer"
            >
              条件のリセット
            </button>
            <button
              type="button"
              onClick={submitSearchHandler}
              className="p-2 bg-primary text-white rounded-sm cursor-pointer"
            >
              絞り込み
            </button>
          </div>
          {/* End Button */}
        </form>
      </div>
      {order && <OrderTable />}
    </div>
  )
}

export default Orders
